import ApiService from "../services/api";

export const fetchCpvs = async (): Promise<string[]> => {
  const apiService = new ApiService();

  try {
    const response = await apiService.get<string[]>("/dealerships/cpvs");
    if (response.status === 200) {
      return response.data;
    }
    return [];
  } catch (error) {
    console.error(error);
    return [];
  }
};
